import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../HardwareFirstQuiz.module.scss';
import { RadioStep as RadioStepDef } from '../steps';

interface RadioStepProps {
  step: RadioStepDef<string>;
  selected: string | null;
  onSelect(optionId: string): void;
}

/**
 * A single-select question. Tapping a row answers and advances, so these steps
 * carry no Next button.
 */
export default function RadioStep({ step, selected, onSelect }: RadioStepProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.stepBody}>
      <h2 className={styles.stepTitle}>{t(step.titleKey)}</h2>
      <div className={styles.options} role="radiogroup" aria-label={t(step.titleKey)}>
        {step.options.map((option) => {
          const isSelected = option.id === selected;
          return (
            <button
              key={option.id}
              type="button"
              role="radio"
              aria-checked={isSelected}
              className={classNames(styles.radioRow, { [styles.radioRowSelected]: isSelected })}
              onClick={() => onSelect(option.id)}
            >
              <span className={classNames(styles.radioMark, { [styles.radioMarkSelected]: isSelected })} />
              <span className={styles.radioText}>
                <span className={styles.radioLabel}>{t(option.labelKey)}</span>
                {option.sublabelKey && <span className={styles.radioSublabel}>{t(option.sublabelKey)}</span>}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
